import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'

export default {
  namespaced: true,

  state () {
    return {
      queries: {
        sortBy: 'venderId',
        sortDirection: 'asc',
        perPage: 20
      },
      isSuccess: false,
      isCountryUs: false,
      completedPayments: [],
      upcomingPayments: [],
      historicPayments: [],
      completedAmount: [],
      upcomingAmount: [],
      historicAmount: [],
      upcomingError: false,
      completedError: false,
      historicError: false,
      setupStatus: 'new',
      pId: '',
      createPay: {
        userId: '',
        vendorId: '',
        foundryName: '',
        addressSection: {
          legalName: '',
          email: '',
          address1: '',
          address2: '',
          city: '',
          state: {
            iso: '',
            name: ''
          },
          zipCode: '',
          country: {
            iso: '',
            name: ''
          },
          phone: ''
        },
        paymentMethodSection: {
          paymentMethod: '',
          minimumPaymentAmount: '',
          payPalEmail: '',
          bankInfo: {
            bankName: '',
            bankCountry: {
              iso: '',
              name: ''
            },
            paymentCurrency: {
              name: '',
              value: ''
            },
            accountNumber: '',
            routingNumber: '',
            iban: '',
            swiftBic: ''
          },
          intermediaryBankInfo: {
            accountNumber: '',
            bankName: '',
            bankCountry: {
              iso: '',
              name: ''
            },
            iban: '',
            paymentCurrency: {
              name: '',
              value: ''
            },
            routingNumber: '',
            swiftBic: ''
          }
        },
        taxInfoSection: {
          ssn: '',
          einTin: '',
          foreignItinTin: '',
          vatNumber: '',
          withholdingCountry: '',
          exemptionRate: '',
          exemptionFrom: '',
          exemptionTo: ''
        }
      }
    }
  },

  getters: {
    completedPay: state => {
      return state.completedPayments
    },
    upcomingPay: state => {
      return state.upcomingPayments
    },
    historicPay: state => {
      return state.historicPayments
    },
    completedAmt: state => {
      return state.completedAmount
    },
    historicAmt: state => {
      return state.historicAmount
    },
    upcomingAmt: state => {
      return state.upcomingAmount
    },
    completedErr: state => {
      return state.completedError
    },
    upcomingErr: state => {
      return state.upcomingError
    },
    historicError: state => {
      return state.historicError
    },
    getPaymentData: state => {
      return state.createPay
    },
    getSetupStatus: state => {
      return state.setupStatus
    },
    isSuccessFull: state => {
      return state.isSuccess
    },
    getIsCountryUs: state => (state.isCountryUs)
  },

  mutations: {
    setupStatus (state, status) {
      state.setupStatus = status
    },
    setCompletedPayments (state, payments = []) {
      state.completedPayments = [...state.completedPayments, ...payments]
    },
    setUpcomingPayments (state, payments) {
      state.upcomingPayments = [...state.upcomingPayments, ...payments]
    },
    setHistoricPayments (state, payments = []) {
      state.historicPayments = [...state.historicPayments, ...payments]
    },
    unsetCompletedPayments (state, len = 20) {
      const temp = [...state.completedPayments]
      temp.length = len
      state.completedPayments = [...temp]
    },
    unsetUpcomingPayments (state, len = 20) {
      const temp = [...state.upcomingPayments]
      temp.length = len
      state.upcomingPayments = [...temp]
    },
    unsetHistoricPayments (state, len = 20) {
      let temp = [...state.historicPayments]
      temp.length = len
      state.historicPayments = [...temp]
    },
    setUpcomingAmount (state, amount) {
      state.upcomingAmount = [...amount]
    },
    setCompletedAmount (state, amount) {
      state.completedAmount = [...amount]
    },
    setHistoricAmount (state, amount) {
      state.historicAmount = [...amount]
    },
    setUpcomingError (state, flag) {
      state.upcomingError = flag
    },
    setCompletedError (state, flag) {
      state.completedError = flag
    },
    setHistoricError (state, flag) {
      state.historicError = flag
    },
    resetPayments (state) {
      state.completedPayments = []
      state.upcomingPayments = []
      state.historicPayments = []
      state.completedAmount = []
      state.upcomingAmount = []
      state.upcomingError = false
      state.completedError = false
      state.historicError = false
    },
    setIsSuccess (state) {
      state.isSuccess = true
    },
    unsetIsSuccess (state) {
      state.isSuccess = false
    },
    resetCreatePay (state) {
      state.createPay = {
        userId: '',
        vendorId: '',
        foundryName: '',
        addressSection: {
          legalName: '',
          email: '',
          address1: '',
          address2: '',
          city: '',
          state: {
            iso: '',
            name: ''
          },
          zipCode: '',
          country: {
            iso: '',
            name: ''
          },
          phone: ''
        },
        paymentMethodSection: {
          paymentMethod: '',
          minimumPaymentAmount: '',
          payPalEmail: '',
          bankInfo: {
            bankName: '',
            bankCountry: {
              iso: '',
              name: ''
            },
            paymentCurrency: {
              name: '',
              value: ''
            },
            accountNumber: '',
            routingNumber: '',
            iban: '',
            swiftBic: ''
          },
          intermediaryBankInfo: {
            bankCountry: {
              iso: '',
              name: ''
            },
            iban: '',
            swiftBic: ''
          }
        },
        taxInfoSection: {
          ssn: '',
          einTin: '',
          foreignItinTin: '',
          vatNumber: '',
          withholdingCountry: '',
          exemptionRate: '',
          exemptionFrom: '',
          exemptionTo: ''
        }
      }
    },
    setPaymentData (state, data) {
      state.createPay = { ...state.createPay, ...data }
    },
    setIsCountryUs (state, data) {
      state.isCountryUs = data
    }
  },

  actions: {
    getAllPayments ({ commit, state }, options = {}, search = null) {
      return new Promise((resolve, reject) => {
        Api.Payments.getPayments(
          options.userId,
          state.queries.sortBy,
          state.queries.sortDirection,
          options.filter,
          search,
          options.page,
          (state.queries.perPage * 1)
        )
          .then((response) => {
            const { data } = response
            if (options.filter === 'upcoming') {
              commit('setUpcomingError', false)
              commit('setUpcomingPayments', data.payments)
              commit('setUpcomingAmount', data.totalAmount)
            } else if (options.filter === 'completed') {
              commit('setCompletedError', false)
              commit('setCompletedPayments', data.payments)
              commit('setCompletedAmount', data.totalAmount)
            } else {
              commit('setHistoricError', false)
              commit('setHistoricPayments', data.payments)
              commit('setHistoricAmount', data.totalAmount)
            }
            resolve({ filter: options.filter, data })
          })
          .catch((error) => {
            const err = Errors.create(error)
            if (options.filter === 'upcoming') {
              commit('setUpcomingError', true)
            } else if (options.filter === 'completed') {
              commit('setCompletedError', true)
            } else {
              commit('setHistoricError', true)
            }
            resolve(err)
          })
      })
    },
    setPayment ({ commit, state }, responseData) {
      return new Promise(resolve => {
        if (state.setupStatus === 'new') {
          commit('setPaymentData', state.createPay)
          resolve(state.createPay)
        } else {
          commit('setPaymentData', responseData)
          resolve(responseData)
        }
      })
    },
    getPaymentData ({ commit, state, dispatch }, options = {}) {
      return new Promise((resolve, reject) => {
        Api.Payments.getPaymentSetupDetails(String(options.userId), String(options.vendorId))
          .then(response => {
            commit('setupStatus', 'edit')
            state.pId = response.data.id
            dispatch('setPayment', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            const err = Errors.create(error)
            reject(err)
          })
      })
    },
    postPayment ({ commit, state }) {
      return new Promise((resolve, reject) => {
        Api.Payments.createPaymentSetup(state.createPay)
          .then(response => {
            if (response?.data) {
              commit('setIsSuccess')
              resolve(response.data)
            }
          })
          .catch((error) => {
            const err = Errors.create(error)
            reject(err)
          })
      })
    },
    putPayment ({ commit, state }, payId = state.pId) {
      return new Promise((resolve, reject) => {
        Api.Payments.updatePaymentSetup(payId, state.createPay)
          .then(response => {
            if (response?.data) {
              commit('setIsSuccess')
              resolve(response.data)
            }
          })
          .catch((error) => {
            const err = Errors.create(error)
            reject(err)
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
